import { render, staticRenderFns } from "./upstreamCustomerList.vue?vue&type=template&id=66bac8ec"
import script from "./upstreamCustomerList.vue?vue&type=script&lang=js"
export * from "./upstreamCustomerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports